//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { required } from 'vuelidate/lib/validators';
import ValidationMixin from '../../../../../common/form/mixins/ValidationMixin';
import TextInput from '../../../../../survey/components/textInput';
import ErrorDisplay from '../../../../../common/ErrorDisplay.vue';
import NumberInput from '../../../../../survey/components/numberInput.vue';
import GroupCheckboxInput from '../../../../../survey/components/groupCheckboxInput.vue';
import SelectInput from '@/components/survey/components/selectInput';
import GroupRadioInput from '@/components/survey/components/groupRadioInput';
import SingleRadioInput from '@/components/survey/components/singleRadioInput';
import SliderInput from '@/components/survey/components/sliderInput';
import SubtitleInput from '@/components/survey/components/subtitle';


export default {
  name: 'RegistrationStepSurveyModal',
  components: {
    SelectInput,
    TextInput,
    ErrorDisplay,
    NumberInput,
    GroupCheckboxInput,
    GroupRadioInput,
    SingleRadioInput,
    SliderInput,
    SubtitleInput,
  },
  mixins: [ValidationMixin],
  props: ['submit', 'completed', 'payload'],
  created() {
    this.$container.eventBus.on('closeModal', (id) => {
      if (id === this.id) {
        this.close();
      }
    });
  },
  data() {
    return {
      open: false,
      loading: false,
      tcAccepted: false,
      error: null,
    };
  },
  // validations: {
  //   name: {
  //     required,
  //   },
  // },
  methods: {
    getErrors() {
      const errors = [];
      return errors;
    },
    async completeSurvey() {
      this.$emit('update:completed', true);
      this.close();
    },
    launch() {
      this.open = true;
      this.$store.dispatch('pushModal', this.id);
    },
    close() {
      this.open = false;
      this.$store.dispatch('popModal');
    },

    isSuperset(set, subset) {
      // eslint-disable-next-line no-restricted-syntax
      for (const elem of subset) {
        if (!set.has(elem)) {
          return false;
        }
      }
      return true;
    },

    satisfy(sq, question) {
      const result = sq.condition === this.payload.answers[question.field] ||
      sq.condition.includes(this.payload.answers[question.field]) ||
      ((Array.isArray(sq.condition)) && (Array.isArray(this.payload.answers[question.field])) && (this.isSuperset(new Set(sq.condition), new Set(this.payload.answers[question.field]))));
      return result;
    },

  },
  computed: {
    formValid() {
      return this.$event === null;
    },
  },
};
